import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
  // 首页
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue'),
    redirect: '/login',
    meta: {
      title: '国医医联煎药中心',
      keepAlive: true,
    },
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/home.vue')
    }, {
      path: '/chineseDrink',
      name: 'chineseDrink',
      component: () => import('@/views/drugManage/chineseDrink.vue')
    }, {
      path: '/hospitalManage',
      name: 'hospitalManage',
      component: () => import('@/views/hospitalManage/hospitalManage.vue')
    }, {
      path: '/packageFee',
      name: 'packageFee',
      component: () => import('@/views/configManage/packageFee.vue')
    }, {
      path: '/processFee',
      name: 'processFee',
      component: () => import('@/views/configManage/processFee.vue')
    }, {
      path: '/receiveManage',
      name: 'receiveManage',
      component: () => import('@/views/orderManage/receiveManage.vue')
    }, {
      path: '/checkManage',
      name: 'checkManage',
      component: () => import('@/views/orderManage/checkManage.vue')
    }, {
      path: '/adjustment',
      name: 'adjustment',
      component: () => import('@/views/orderManage/adjustment.vue')
    }, {
      path: '/review',
      name: 'review',
      component: () => import('@/views/orderManage/review.vue')
    }, {
      path: '/bubbleMedicine',
      name: 'bubbleMedicine',
      component: () => import('@/views/orderManage/bubbleMedicine.vue')
    }, {
      path: '/boilMedicine',
      name: 'boilMedicine',
      component: () => import('@/views/orderManage/boilMedicine.vue')
    }, {
      path: '/packageManage',
      name: 'packageManage',
      component: () => import('@/views/orderManage/packageManage.vue')
    }, {
      path: '/sendManage',
      name: 'sendManage',
      component: () => import('@/views/orderManage/sendManage.vue')
    }, {
      path: '/prescriptionQuery',
      name: 'prescriptionQuery',
      component: () => import('@/views/orderManage/prescriptionQuery.vue')
    }, {
      path: '/income',
      name: 'income',
      component: () => import('@/views/statisticsManage/income.vue')
    }, {
      path: '/monthGoods',
      name: 'monthGoods',
      component: () => import('@/views/statisticsManage/monthGoods.vue')
    }, {
      path: '/profitDrugSale',
      name: 'profitDrugSale',
      component: () => import('@/views/statisticsManage/profitDrugSale.vue')
    }, {
      path: '/stockIn',
      name: 'stockIn',
      component: () => import('@/views/statisticsManage/stockIn.vue')
    }, {
      path: '/stockOut',
      name: 'stockOut',
      component: () => import('@/views/statisticsManage/stockOut.vue')
    }, {
      path: '/inStock',
      name: 'inStock',
      component: () => import('@/views/stockManage/inStock.vue')
    }, {
      path: '/outStock',
      name: 'outStock',
      component: () => import('@/views/stockManage/outStock.vue')
    }, {
      path: '/plantManage',
      name: 'plantManage',
      component: () => import('@/views/stockManage/plantManage.vue')
    }, {
      path: '/stockCheck',
      name: 'stockCheck',
      component: () => import('@/views/stockManage/stockCheck.vue')
    }, {
      path: '/addStockCheck',
      name: 'addStockCheck',
      component: () => import('@/views/stockManage/addStockCheck.vue')
    }, {
      path: '/stockManage',
      name: 'stockManage',
      component: () => import('@/views/stockManage/stockManage.vue')
    }, {
      path: '/stockWarning',
      name: 'stockWarning',
      component: () => import('@/views/stockManage/stockWarning.vue')
    }, {
      path: '/transferManage',
      name: 'transferManage',
      component: () => import('@/views/stockManage/transferManage.vue')
    }, {
      path: '/dictionary',
      name: 'dictionary',
      component: () => import('@/views/systemManage/dictionary.vue')
    }, {
      path: '/drugPrice',
      name: 'drugPrice',
      component: () => import('@/views/systemManage/drugPrice.vue')
    }, {
      path: '/role',
      name: 'role',
      component: () => import('@/views/systemManage/role.vue')
    }, {
      path: '/user',
      name: 'user',
      component: () => import('@/views/systemManage/user.vue')
    }, {
      path: '/cameraManage',
      name: 'cameraManage',
      component: () => import('@/views/systemManage/cameraManage.vue')
    }, {
      path: '/systemParam',
      name: 'systemParam',
      component: () => import('@/views/systemManage/systemParam.vue')
    }, {
      path: '/device',
      name: 'device',
      component: () => import('@/views/systemManage/device.vue')
    }, {
      path: '/processConfig',
      name: 'processConfig',
      component: () => import('@/views/systemManage/processConfig.vue')
    }, {
      path: '/printManage',
      name: 'printManage',
      component: () => import('@/views/systemManage/printManage.vue')
    }, {
      path: '/boilPlan',
      name: 'boilPlan',
      component: () => import('@/views/systemManage/boilPlan.vue')
    }, {
      path: '/SFTemplateManage',
      name: 'SFTemplateManage',
      component: () => import('@/views/systemManage/SFTemplateManage.vue')
    }, {
      path: '/expressManage',
      name: 'expressManage',
      component: () => import('@/views/systemManage/expressManage.vue')
    }, {
      path: '/incomeStatistics',
      name: 'incomeStatistics',
      component: () => import('@/views/statisticsManageNew/incomeStatistics.vue')
    }, {
      path: '/stockStatistics',
      name: 'stockStatistics',
      component: () => import('@/views/statisticsManageNew/stockStatistics.vue')
    }, {
      path: '/performanceStatistics',
      name: 'performanceStatistics',
      component: () => import('@/views/statisticsManageNew/performanceStatistics.vue')
    }]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/views/orderManage/printPrescription.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
